'use strict';

import {
  listenAddToCartButton,
  enableAddToCartButton,
  disableAddToCartButton
} from './detailsPage/addToCart';
import {
  classes,
  addClassToElement,
  removeClassToElement
} from '@jspartials/class-list-utils';
import { listenDOMEvent } from '@jspartials/dom-api-utils';
import { listenAddToCartContactLenses } from './detailsPage/contactLenses/addToCart';

import GraduationsList from '@jsclasses/graduationsList';

const selector = {
  wrapper: {
    subscriptionPlans: '.js-wrapper-subscription-plans',
    productPrice: '.js-wrapper-product-price'
  },
  input: {
    subscriptionPurchase: '.js-input-subscription-purchase',
    singlePurchase: '.js-input-single-purchase',
    sameGraduationBothEyes: '.js-input-same-graduation-both-eyes',
    legalConditionsWrapper: '.js-contact-lenses-legal-conditions-wrapper',
    legalConditions: '.js-input-legal-conditions',
    graduationLeftEye: '.js-input--graduation-left-eye',
    graduationRightEye: '.js-input--graduation-right-eye'
  },
  stepIndicatorGraduation: '.js-step-indicator-graduation',
  graduations: {
    leftEye: '.js-graduations-left-eye',
    rightEye: '.js-graduations-right-eye',
    list: '.js-graduation-list'
  },
  select: {
    graduation: '.js-graduation__value'
  }
};

const element = {
  wrapper: {
    subscriptionPlans:
      document.querySelector(selector.wrapper.subscriptionPlans) || null,
    productPrice: document.querySelectorAll(selector.wrapper.productPrice) || []
  },
  input: {
    subscriptionPurchase:
      document.querySelector(selector.input.subscriptionPurchase) || null,
    singlePurchase:
      document.querySelector(selector.input.singlePurchase) || null,
    sameGraduationBothEyes:
      document.querySelector(selector.input.sameGraduationBothEyes) || null,
    legalConditionsWrapper:
      document.querySelector(selector.input.legalConditionsWrapper) || null,
    legalConditions:
      document.querySelector(selector.input.legalConditions) || null,
    graduationLeftEye:
      document.querySelector(selector.input.graduationLeftEye) || null,
    graduationRightEye:
      document.querySelector(selector.input.graduationRightEye) || null
  },
  stepIndicatorGraduation:
    document.querySelector(selector.stepIndicatorGraduation) || null,
  graduations: {
    leftEye: document.querySelector(selector.graduations.leftEye) || null,
    rightEye: document.querySelector(selector.graduations.rightEye) || null
  }
};

// Variables
let sameGraduationBothEyes = false;
const graduationsLeftEye = new GraduationsList({
  wrapper: document.querySelector('.js-graduations-left-eye'),
  input: document.querySelector('.js-input--graduation-left-eye')
});
const graduationsRightEye = new GraduationsList({
  wrapper: document.querySelector('.js-graduations-right-eye'),
  input: document.querySelector('.js-input--graduation-right-eye')
});

const showSubscriptionPlans = () => {
  if (element.wrapper.subscriptionPlans) {
    removeClassToElement(element.wrapper.subscriptionPlans, classes.hidden);
  }

  if (element.stepIndicatorGraduation) {
    element.stepIndicatorGraduation.textContent = 3;
  }

  hideProductPrices();
};

const hideSubscriptionPlans = () => {
  if (element.wrapper.subscriptionPlans) {
    addClassToElement(element.wrapper.subscriptionPlans, classes.hidden);
  }

  if (element.stepIndicatorGraduation) {
    element.stepIndicatorGraduation.textContent = 2;
  }

  showProductPrices();
};

const hideProductPrices = () => {
  element.wrapper.productPrice.forEach((productPrice) => {
    addClassToElement(productPrice, classes.hidden);
  });

  //TODO: Remove this when we are able to update prices dynamically
  addClassToElement(
    document.querySelector('.js-pdp__product-info-mobile .js-product-price'),
    classes.hidden
  );
};

const showProductPrices = () => {
  element.wrapper.productPrice.forEach((productPrice) => {
    removeClassToElement(productPrice, classes.hidden);
  });

  //TODO: Remove this when we are able to update prices dynamically
  removeClassToElement(
    document.querySelector('.js-pdp__product-info-mobile .js-product-price'),
    classes.hidden
  );
};

const validateAddToCart = () => {
  const graduationLeftEye = element.input.graduationLeftEye.value;
  const graduationRightEye = element.input.graduationRightEye.value;

  if (graduationLeftEye && graduationRightEye) {
    removeClassToElement(
      element.graduations.leftEye.closest('.js-field--graduation'),
      classes.has.error
    );
    removeClassToElement(
      element.graduations.rightEye.closest('.js-field--graduation'),
      classes.has.error
    );
    enableAddToCartButton();
  } else {
    if (graduationLeftEye) {
      removeClassToElement(
        element.graduations.leftEye.closest('.js-field--graduation'),
        classes.has.error
      );
    }
    if (graduationRightEye) {
      removeClassToElement(
        element.graduations.rightEye.closest('.js-field--graduation'),
        classes.has.error
      );
    }
  }
};
const validateCheckbox = () => {
  const legalConditionsAccepted = element.input.legalConditions.checked;

  if (legalConditionsAccepted) {
    const legalConditionsWrapper = element.input.legalConditionsWrapper;
    if (legalConditionsWrapper) {
      removeClassToElement(legalConditionsWrapper, classes.has.error);
    }
  }
};

const matchGraduations = () => {
  const valueToCopy = element.input.graduationLeftEye.value;
  const leftEyeGraduationValueElement =
    element.graduations.leftEye.querySelector(selector.select.graduation);
  const rightEyeGraduationValueElement =
    element.graduations.rightEye.querySelector(selector.select.graduation);

  element.input.graduationRightEye.value = valueToCopy;
  rightEyeGraduationValueElement.textContent =
    leftEyeGraduationValueElement.textContent;
};

document.addEventListener('DOMContentLoaded', function () {
  listenAddToCartContactLenses();
  element.graduations.leftEye.addEventListener('click', function () {
    const list = element.graduations.rightEye.querySelector(
      selector.graduations.list
    );
    if (list) {
      addClassToElement(list, classes.hidden);
    }
  });

  element.graduations.rightEye.addEventListener('click', function () {
    const list = element.graduations.leftEye.querySelector(
      selector.graduations.list
    );
    if (list) {
      addClassToElement(list, classes.hidden);
    }
  });

  // When the graduation select for left eye changes
  listenDOMEvent(element.input.graduationLeftEye, 'change', function () {
    if (sameGraduationBothEyes) {
      matchGraduations();
    }

    validateAddToCart();
  });

  // When the graduation select for right eye changes
  listenDOMEvent(element.input.graduationRightEye, 'change', function () {
    validateAddToCart();
  });

  // When the legal conditions checkbox changes
  listenDOMEvent(element.input.legalConditions, 'change', function () {
    validateCheckbox();
  });

  // Wants the same graduation for both eyes
  listenDOMEvent(element.input.sameGraduationBothEyes, 'change', function () {
    if (this.checked) {
      sameGraduationBothEyes = true;
      matchGraduations();
      addClassToElement(element.graduations.rightEye, classes.is.disabled);
    } else {
      sameGraduationBothEyes = false;
      removeClassToElement(element.graduations.rightEye, classes.is.disabled);
    }

    validateAddToCart();
  });

  // Select subscription purchase
  if (element.input.subscriptionPurchase) {
    listenDOMEvent(element.input.subscriptionPurchase, 'change', function () {
      if (this.checked) {
        showSubscriptionPlans();
      }
    });
  }

  // Select single purchase
  if (element.input.singlePurchase) {
    listenDOMEvent(element.input.singlePurchase, 'change', function () {
      if (this.checked) {
        hideSubscriptionPlans();
      }
    });
  }

  graduationsLeftEye.init();
  graduationsRightEye.init();
});
